export function isomResearhHighlightBlock() {
    'use strict';
    const rshGroup = $('.isom-research-highlight .rsh_group');
    const rshGroupContent = $('.isom-research-highlight .rsh_group .rsh_group_content');
    rshGroup.each(function () {
        const thisGroup = $(this);
        const thisGroupContent = thisGroup.find('.rsh_group_content');
        const groupTitle = thisGroup.find('.rsh_group_title');
        groupTitle.on('click', function () {
            //rshGroup.removeClass('expanded').addClass('collapsed');
            //rshGroupContent.not(thisGroupContent).slideUp();
            if (thisGroupContent.is(':visible')) {
                thisGroupContent.slideUp(function () {
                    thisGroup.removeClass('expanded').addClass('collapsed');
                });
            } else {
                thisGroupContent.slideDown();
                thisGroup.removeClass('collapsed').addClass('expanded');
            }
        });
    });
}
